// Re-export from weekly (same structure)
export {
  weekStartOptions,
  hoursOpenPerDayOptions,
  WEEKLY_SPECIFIC_FIELDS as MONTHLY_SPECIFIC_FIELDS,
  WEEKLY_ADVANCED_FIELDS as MONTHLY_ADVANCED_FIELDS,
  DAY_DISTRIBUTION_FIELDS,
} from "@/features/weekly/constants/form"

/**
 * Weeks per month constant (used for monthly-to-weekly conversion display)
 */
export const WEEKS_PER_MONTH = 4.35
